import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ListOfReports from './components/ListOfReports'

import { getCookie } from "utils/cookies";
import { getOneOperatorApi } from "api/operator";
import { Spinner } from "@material-tailwind/react";

function InventoryManagement() {
  const { userID } = useParams();
  const [accessList, setAccessList] = useState({})
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getAccessList()
  }, [])

  const getAccessList = async () => {
    try {
      setIsLoading(true)

      const id = getCookie("3F2Mb2pJ1YRro5Z4")
      const adminRole = getCookie("lv9u765qzk1gr4fn1e")

      if(adminRole === "FALSE") {
        const response = await getOneOperatorApi(id)
        const accessList = response.userFromRole.access

        const selectedAccessDetails = accessList.find(el => el.value._id == userID)

        const accessObject = {
          Add: false,
          Read: false,
          Update: false,
          Delete: false,
          BI: false,
          BL: false,
          BR: false,
          AI: false,
          Validation: false,
          pdf_excel: false
        }

        selectedAccessDetails.sectionItems.map(el => {
          if(el.value == "Add" && el.checked) {
            accessObject.Add = true
          }
          if(el.value == "Read" && el.checked) {
            accessObject.Read = true
          }
          if(el.value == "Update" && el.checked) {
            accessObject.Update = true
          }
          if(el.value == "Delete" && el.checked) {
            accessObject.Delete = true
          }

          if(el.value == "BI" && el.checked) {
            accessObject.BI = true
          }
          if(el.value == "AI" && el.checked) {
            accessObject.AI = true
          }
          if(el.value == "BL" && el.checked) {
            accessObject.BL = true
          }
          if(el.value == "BR" && el.checked) {
            accessObject.BR = true
          }
          if(el.value == "Validation" && el.checked) {
            accessObject.Validation = true
          }
          if(el.value == "pdf_excel" && el.checked) {
            accessObject.pdf_excel = true
          }
        })

        setAccessList({
          Add: accessObject.Add,
          Read: accessObject.Read,
          Update: accessObject.Update,
          Delete: accessObject.Delete,

          BI: accessObject.BI,
          AI: accessObject.AI,
          BL: accessObject.BL,
          BR: accessObject.BR,
          Validation: accessObject.Validation,
          pdf_excel: accessObject.pdf_excel,
        })
      }
      else if(adminRole === "TRUE") {
        setAccessList({
          Add: true,
          Read: true,
          Update: true,
          Delete: true,
          BI: true,
          BL: true,
          BR: true,
          AI: true,
          Validation: true,
          pdf_excel: true
        })
      }
    }
    catch (err) {
      console.log(err)
    }
    finally {
      setIsLoading(false)
    }
  }

  return (
    <div>
      {
        isLoading ?
        <div className="flex items-center justify-center">
          <Spinner className="h-12 w-12" />
        </div> :
        <ListOfReports accessList={accessList} />
      }
    </div>
  )
}

export default InventoryManagement
